/**
 * @property {string} resourceTypeId
 * @property {string} label
 * @property {string} price
 * @property {Date} orderDate
 */
export default class ConsumptionPurchaseHistoryEntry {
  /**
   * @param {string} resourceTypeId
   * @param {string} label
   * @param {string} price
   * @param {string} orderDate
   */
  constructor({ resourceTypeId, label, price, orderDate }) {
    this.resourceTypeId = resourceTypeId;
    this.label = label;
    this.price = price;
    this.orderDate = new Date(orderDate);
  }
}
